function sendMessage(data) {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(data);
  } else {
    window.parent.postMessage(data, '*');
  }
}

export function fireReadyEvent() {
  sendMessage('ready');
}

export function floorLoadedEvent() {
  sendMessage('floorReady');
}

export function sendUserOnResident(residentPolygon) {
  const data = JSON.stringify({
    command: 'goToStore',
    data: {
      residentSlug: residentPolygon.content_object.slug,
      residentTitle: residentPolygon.content_object.title,
      type: residentPolygon.resident_type,
      logo: residentPolygon.content_object.logo,
      other: residentPolygon.content_object
    }
  });
  sendMessage(data);
}

export function changeFloor(floorId) {
  sendMessage(
    JSON.stringify({
      command: 'changeFloor',
      data: {
        floorId
      }
    })
  );
}
